import type { LongTermGoalInput } from "@/types";

/**
 * How far along a long-term goal is, as 0–100 — or null when this client cannot
 * know. `byTasks` goals derive their progress from their tasks, which the web
 * console does not track yet, so they report null rather than a misleading zero.
 */

const PCT_MIN = 0;
const PCT_MAX = 100;

export function goalProgressPct(goal: LongTermGoalInput, now: number = Date.now()): number | null {
  switch (goal.progressMode) {
    case "manual":
      return clampPct(goal.progressPct ?? PCT_MIN);
    case "byTime":
      return elapsedPct(goal.startAt, goal.deadlineAt, now);
    case "byTasks":
      return null;
  }
}

/** Share of the goal's window that has elapsed. Null for a malformed window. */
function elapsedPct(startAt: string, deadlineAt: string, now: number): number | null {
  const start = new Date(startAt).getTime();
  const deadline = new Date(deadlineAt).getTime();
  const span = deadline - start;
  if (!Number.isFinite(span) || span <= 0) return null;
  return clampPct(((now - start) / span) * PCT_MAX);
}

function clampPct(value: number): number {
  return Math.round(Math.min(PCT_MAX, Math.max(PCT_MIN, value)));
}
